import React from 'react';
import { Button, Card, Status } from '@/components';

const ExamplePage: React.FC = () => {
  const folders = [
    {
      title: 'components',
      description: 'Shared UI building blocks used across every module.',
    },
    {
      title: 'pages',
      description: 'Feature screens grouped by business domain.',
    },
    {
      title: 'services/api',
      description: 'HTTP requests and API-specific payload types.',
    },
    {
      title: 'types',
      description: 'Shared interfaces, route types, and domain models.',
    },
  ];

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-semibold text-text-strong-950 mb-2">
          Example module
        </h1>
        <p className="text-sm text-text-sub-600 max-w-2xl">
          Keep this page as a reference when creating new modules. It shows the
          expected layout rhythm, card usage, actions, and status badges.
        </p>
      </div>

      <Card title="Project conventions">
        <div className="grid gap-4 md:grid-cols-2">
          {folders.map((folder) => (
            <div
              key={folder.title}
              className="rounded-xl border border-stroke-soft-200 p-4 bg-bg-weak-50"
            >
              <div className="flex items-center justify-between mb-3">
                <h2 className="text-base font-semibold text-text-strong-950">
                  {folder.title}
                </h2>
                <Status value="active" type="feedback" />
              </div>
              <p className="text-sm text-text-sub-600">{folder.description}</p>
            </div>
          ))}
        </div>
      </Card>

      <Card title="Common actions">
        <div className="flex flex-wrap gap-3">
          <Button>Add record</Button>
          <Button variant="secondary">Open modal</Button>
          <Button variant="white">Export data</Button>
          <Button variant="danger">Delete</Button>
        </div>
      </Card>
    </div>
  );
};

export default ExamplePage;
